var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Box, Divider, Stack } from '@mui/material';
import { RevisionDetails } from './RevisionDetails';
import { RevisionList } from './RevisionList';
export var RevisionListWithDetails = function (props) {
    var allowRevert = props.allowRevert, diff = props.diff, onRevert = props.onRevert, record = props.record, _a = props.renderName, renderName = _a === void 0 ? function (id) { return id; } : _a, resource = props.resource, sx = props.sx;
    var _b = React.useState(), revision = _b[0], setRevision = _b[1];
    return (_jsxs(Stack, { direction: "row", sx: __spreadArray([
            {
                gap: 2,
                alignItems: 'flex-start',
                width: '100%',
            }
        ], (Array.isArray(sx) ? sx : [sx]), true), children: [_jsx(Box, { className: "revision_list", sx: {
                    width: 250,
                }, children: _jsx(RevisionList, { record: record, renderName: renderName, resource: resource, onRevisionClick: setRevision, keepSelection: true, sx: { width: 'inherit' } }) }), revision && _jsx(Divider, { orientation: "vertical", flexItem: true }), revision && (_jsx(Box, { className: "revision_details", sx: {
                    flex: '1',
                }, children: _jsx(RevisionDetails, { revision: revision, renderName: renderName, onRevert: onRevert, diff: diff, allowRevert: allowRevert }) }))] }));
};
